import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { loginComponent } from './login/login.component';
import { ProfileComponent } from './profile/profile.component';
import { SignupComponent } from './signup/signup.component';
import { ProfessionalExperienceModalComponent, EducationModalComponent, 
    ProfessionalCertificatesModalComponent, VoluntaryModalComponent,
    LanguageModalComponent, ReferencesModalComponent , InterestModalComponent, DeleteConfirmationModalComponent} from './profile/modals';
import { TableComponent } from './profile/table-component/table-component';
import { ProfExperienceComponent } from './profile/prof-exp-component/prof-exp-component';
import { EducationTableComponent } from './profile/education-component/education-component';
import { RefrenceTableComponent } from './profile/reference-component/reference-component';
import { LanguageTableComponent } from './profile/language-component/language-component';
import { ProfCertTableComponent } from './profile/prof-cert-component/prof-cert-component';
import { VoluntaryTableComponent } from './profile/voluntary-component/voluntary-component';
import { InterestTableComponent } from './profile/interest-component/interest-component';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MaskDirective } from './profile/phone-mask.directive';
import { TelMaskDirective } from './profile/tel-mask.directive';
import { ArabicMaskDirective } from './profile/arabic-mask.directive';

import { CanidadateCVComponent } from './cv/candidate-cv.component';

import { ToastrModule } from 'ngx-toastr';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        NgbModule,
        BrowserAnimationsModule,
        ToastrModule.forRoot()
    ],
    declarations: [
        loginComponent,
        SignupComponent,
        ProfileComponent,
        ProfessionalExperienceModalComponent,
        EducationModalComponent,
        ProfessionalCertificatesModalComponent,
        VoluntaryModalComponent,
        LanguageModalComponent,
        ReferencesModalComponent,
        InterestModalComponent,
        TableComponent,
        ProfExperienceComponent,
        EducationTableComponent,
        RefrenceTableComponent,
        LanguageTableComponent,
        ProfCertTableComponent,
        VoluntaryTableComponent,
        InterestTableComponent,
        MaskDirective,
        ArabicMaskDirective,
        TelMaskDirective,
        DeleteConfirmationModalComponent,
        CanidadateCVComponent
    ]
})
export class UserModule { }
